var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "bmui-segment" },
    _vm._l(_vm.items, function(item, i) {
      return _c(
        "label",
        {
          key: i,
          class: [
            "bmui-segment-item",
            { "bmui-segment-active": _vm.indexInside === i }
          ]
        },
        [
          _c("div", { staticClass: "bmui-segment-box" }, [
            _c("div", { staticClass: "bmui-segment-box2" }, [
              _c(
                "button",
                {
                  staticClass: "bmui-segment-text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.indexInside = i
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      (typeof item === "string" ? item : item.name) || "ITEM"
                    )
                  )
                ]
              ),
              _vm._v(" "),
              typeof item.mark === "number"
                ? _c(
                    "i",
                    {
                      class:
                        item.mark > 9
                          ? "bmui-segment-mark"
                          : "bmui-segment-single-mark"
                    },
                    [_vm._v(_vm._s(item.mark > 99 ? "99+" : item.mark))]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.mark === "redMark"
                ? _c("i", { staticClass: "bmui-segment-redMark" })
                : _vm._e()
            ])
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81de1c08", { render: render, staticRenderFns: staticRenderFns })
  }
}